import { environment } from 'src/environments/environment';


export const FontsUrl = {
    frutiger: {
        bold: environment.fontsUrls.frutiger.bold,
        medium: environment.fontsUrls.frutiger.medium,
        normal: environment.fontsUrls.frutiger.normal
    }
};
